<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        
        <h3>Signup</h3>

        <div class="p-field p-grid">
          <label for="email" class="p-col-12 p-mb-1 p-md-1 p-mb-md-0"
            >Email*:</label
          >
          <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0">
            <InputText
              id="email"
              type="email"
              placeholder="Enter your email"
              v-model="user.email"
              autofocus
            ></InputText>
          </div>
        </div>
        <div class="p-field p-grid">
          <label for="First Name" class="p-col-12 p-mb-1 p-md-1 p-mb-md-0"
            >First Name:
          </label>
          <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0">
            <InputText
              id="firstName"
              v-model.trim="user.firstName"
              required="false"
            />
          </div>
        </div>
        <div class="p-field p-grid">
          <label for="lastName" class="p-col-12 p-mb-1 p-md-1 p-mb-md-0"
            >Surname:
          </label>
          <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0">
            <InputText
              id="lastName"
              v-model.trim="user.lastName"
              required="false"
            />
          </div>
        </div>
        <div class="p-field p-grid">
          <label for="password" class="p-col-12 p-mb-1 p-md-1 p-mb-md-0"
            >Password:
          </label>
          <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0">
            <InputText
              id="password"
              type="password"
              v-model.trim="user.password"
              required="false"
            />
          </div>
        </div>
        <div class="p-field p-grid">
          <h3>error + {{ feedback }}</h3>
        </div>
        <template>
          <Button
            label="Cancel"
            icon="pi pi-times"
            class="p-button-text"
            @click="hideDialog"
          />
          <Button
            label="Save"
            icon="pi pi-check"
            class="p-button-text"
            @click="Signup"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/service/UserService";
import firebase from "firebase";

//import ProductService from '../service/ProductService';

export default {
  data() {
    return {
      users: null,
      user: {},
      options: [true, false],
      feedback: null,
      dropdownValues: [
        { name: "New York", code: "NY" },
        { name: "Rome", code: "RM" },
        { name: "London", code: "LDN" },
        { name: "Istanbul", code: "IST" },
        { name: "Paris", code: "PRS" },
      ],
    };
  },
  userService: null,
  created() {
    this.userService = new UserService();
  },
  async mounted() {
    // this.userService.getAllUsers().then((data) => (this.users = data));
    this.loading1 = false;
  },
  methods: {
    async Signup() {
      //this.user = {};
      //this.submitted = false;
      // Call endpoint to complete Signup
      
      this.feedback = '';
      if (this.user.email && this.user.password) {
        firebase
          .auth()
          .createUserWithEmailAndPassword(this.user.email, this.user.password)
          .then((cred) => {
            
            this.userService
              .completeSignup(cred.user)
              .then((response) => {
                this.$toast.add({
                  severity: "success",
                  summary: response.data,
                  detail: "New User created successfully",
                  life: 5000,
                });
                this.user = {};
              })
              .catch((e) => {
                
                
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: "Error while creating user",
                  life: 5000,
                })
              });
          })
          .catch((err) => {
            
            this.feedback = err.message;
                
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: err.message,
              life: 5000,
            })
            
          });
      }
    },
    hideDialog() {
      
    }
  }
};
</script>

<style scoped lang="scss">
.p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.p-datatable.p-datatable-customers {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  .p-datatable {
    &.p-datatable-customers {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        border-bottom: 1px solid var(--layer-2);

        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>





